import React, { useEffect, useState, useMemo } from "react"
import { get, isEmpty, filter, mapValues, merge } from "lodash"
import { withRouter } from "react-router"
import { statisticsApiCall } from "components/actions/divisionStatistics"
import { DomesticSummaryTemplate } from "components/templates/domestic/summary"
import { APIResponse } from "redux/apis/types"
import APIs from "redux/apis"
import { getRequestName } from "config/apiConst"
import { worldRankingState, worldRankingApi } from "components/actions/ranking"
import { Sort } from "utils/sort"
import { Config } from "config/config"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useLodingTrigger, LoadingTriger } from "components/actions/loading"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

type Props = {
  pathName: string
  setApiRes: Function
}

//dummyとして
// const ipoInitialData: IPODataType = {
//   today: {
//     ResultList: [{}],
//   },
//   future: {
//     ResultList: [{}, {}, {}, {}, {}],
//   },
//   past: {
//     ResultList: [{}, {}, {}],
//   },
// }

const IPO_CONST = {
  today: 0,
  future: 1,
  past: 2,
}

export const DomesticSummary = withRouter(({ history, location }) => {
  const [indexData, setIndex] = useState<APIResponse.Res | {}>({})
  const [industryData, setIndustryData] = useState<APIResponse.Res | {}>({})
  const [statisticsData, updateStatistics] = useState([])
  const [rankingData, changeRanking] = useState<worldRankingState>({
    exchangeTypeNum: 0,
    priceIncreaseList: [],
    priceReductionList: [],
    volumeList: [],
    priceIncreaseTime: "",
    priceReductionTime: "",
    volumeTime: "",
  })
  const [ipoData, setIpoData] = useState(null)
  const [indicatorData, changeIndicatorData] = useState([])
  const [indicatorDay, changeIndicatorDay] = useState(0)
  const [indicatorPage, changeIndicatorPage] = useState(0)
  const indicatorApiParam = [
    "Country.JP.Today",
    "Country.JP.PrevDays",
    "Country.JP.NextDays",
  ]
  const indicatorItem = {
    data: indicatorData,
    changeData: changeIndicatorData,
    selectDay: indicatorDay,
    changeDay: changeIndicatorDay,
    currentPage: indicatorPage,
    changePage: changeIndicatorPage,
  }
  const loadResistId = useMemo(() => uuid(), [])
  const { loading, setLoading } = useLodingTrigger()
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const requestIndex = async (props: Props) => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    const priceList: APIResponse.Res | {} = await APIs.SymbolDetail.PriceList({
      Name: getRequestName(props.pathName) || props.pathName,
    })
    props.setApiRes(priceList)
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  const requestIpo = async (props: { setData: Function }) => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    const res = await APIs.ChangedSymbol.IPOSymbol({
      _orderBy: "ApplyDayFrom",
    })
    const _ipoData = mapValues(IPO_CONST, id => {
      return {
        ResultList: filter<object>(
          get(res, "ResultList", {}),
          (data: object) => {
            return (
              get(data, "SortID") === id &&
              isEmpty(get(data, "ListedExchangeDivisions"))
            )
          }
        ),
      }
    })
    props.setData(merge(_ipoData, { ServerTime: get(res, "ServerTime") }))
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  const requestIndicatorList = async (props: { setData: Function }) => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    const indicatorList:
      | APIResponse.Res
      | {} = await APIs.SymbolDetail.IndicatorList({
      Name: indicatorApiParam[indicatorDay],
      // _take: PAGE_NUM.PAGE_10,
      // _skip: PAGE_NUM.PAGE_10 * indicatorPage,
    })
    props.setData(get(indicatorList, "ResultList"))
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  const requestApi = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    Promise.all([
      requestIndex({
        pathName: "Jpn.Industry.Main",
        setApiRes: setIndustryData,
      }),
      requestIndex({
        pathName: location.pathname,
        setApiRes: setIndex,
      }),
      worldRankingApi({
        exchangeTypeNum: 0,
        priceIncrease: Sort.DomesticSummaryRankingExchange[0].priceIncrease,
        priceReduction: Sort.DomesticSummaryRankingExchange[0].priceReduction,
        volume: Sort.DomesticSummaryRankingExchange[0].volume,
        changeRanking: changeRanking,
      }),
      statisticsApiCall({
        updateStatistics: updateStatistics,
        division: "0111,0114,0124",
      }),
      requestIpo({
        setData: setIpoData,
      }),
    ]).then(() => {
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }
  useEffect(() => {
    requestApi()
  }, [])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) requestApi()
  }, [isPageLoading])

  useEffect(() => {
    requestIndicatorList({ setData: changeIndicatorData })
  }, [indicatorDay])

  //ランキングポーリング(1回/15sec)
  useEffect(() => {
    let polling = setInterval(() => {
      const exchangeTypeNum = get(rankingData, "exchangeTypeNum")
      const rankingType = Sort.DomesticSummaryRankingExchange[exchangeTypeNum]
      worldRankingApi({
        exchangeTypeNum: exchangeTypeNum,
        priceIncrease: rankingType.priceIncrease,
        priceReduction: rankingType.priceReduction,
        volume: rankingType.volume,
        changeRanking: changeRanking,
      })
    }, Config.api.rankingPollingInterval)
    return () => {
      clearInterval(polling)
    }
  }, [rankingData])

  useEffect(() => {
    if (!loading) return
    setLoading(false)
    requestIndex({
      pathName: location.pathname,
      setApiRes: setIndex,
    })
  }, [loading])

  return (
    <LoadingTriger.Provider value={{ loading, setLoading }}>
      <DomesticSummaryTemplate
        indexData={get(indexData, "ResultList")}
        setIndexData={setIndex}
        statisticsData={statisticsData}
        updateStatistics={updateStatistics}
        ipoData={ipoData}
        setIpoData={setIpoData}
        rankingData={rankingData}
        changeRanking={changeRanking}
        callRankingApi={worldRankingApi}
        industryData={industryData}
        setIndustryData={setIndustryData}
        indicatorItem={indicatorItem}
        history={history}
        requestIndex={requestIndex}
        requestIpo={requestIpo}
        requestIndicatorList={requestIndicatorList}
      />
    </LoadingTriger.Provider>
  )
})
